import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classnames from "classnames";
import axios from "axios";
import SupportContainer from '../home/SupportContainer';
import $ from 'jquery';

class ResetPassword extends Component {
    constructor() {
        super();

        this.state = {
            email:"",
            msg:"",
            password:"",
            cpassword:"",
            showError:false,
            type:"1",
            errors: {},
			showHelpPopup: false,
			passMinError: false,
			specialSymbol: false,
			numberContain: false,
			letterContain: false,
			supportPageName: 'Reset Password',
			supportPageApi: '/resetpassword',
			userTypeFaqs: 1
          };


    }


    componentDidMount() {

      let email=this.props.location.state.email;

      this.setState({
        email:this.props.location.state.email,
       
      });

    }

    componentWillMount(){

    }
	
	checkValidation=(e)=>{
		let showHelp = this.state.showHelpPopup;
		
		if ( this.state.password.length == 0 ) { showHelp = false; }
		else { showHelp = true; }
		
		let checking = this.checkPassword(this.state.password);
		
		this.setState({
			showHelpPopup: showHelp
		});
		if ( checking )
			{
				let mainthis = this;
				setTimeout(function(){ 
					mainthis.setState({
						showHelpPopup: false
					});
				}, 1000);

			}
	}	

	checkPassword=(pass)=>{
		let checkAll = false;
		var regexcheck = /[!@#$%_+:;'"~`.,?|\^&*(){}[\]<>?/|\-]/;
		var contains_number = /\d+/;
		var Regex = /^[^a-zA-Z]*$/;
		
		this.setState({
			contain8Ch: false,
			specialSymbol: false,
			numberContain: false,
			letterContain: false
		});
		
		if ( !Regex.test(pass) ) 
			{ 
				this.setState({
					letterContain: true
				});
			}
		
		if ( pass.length >= 8 )
			{
				this.setState({
					contain8Ch: true
				});
			}
		
		if ( regexcheck.test(pass) )
			{
				this.setState({
					specialSymbol: true
				});
			}
			
		if ( contains_number.test(pass) )
			{
				this.setState({
					numberContain: true
				});
			}
			
		if ( pass != '' && pass.length >= 8 && regexcheck.test(pass) && contains_number.test(pass) && !Regex.test(pass) )
			{
				checkAll = true;
			}
			
		return checkAll;
	}

    handleChange= name => e => {
        this.setState({[name]: e.target.value});
      };


    resetPassword = e => {
        e.preventDefault();
                     
        if(this.state.password == "" || this.state.cpassword == "")
        {
          this.setState({
            msg:'Password and Confirm Password field should not blank',
          });
        }else if(this.state.password != this.state.cpassword)
        {
          this.setState({
            msg:'Password and Confirm Password should be matched',
          });

        }else{

          this.setState({show_loader: true});
          const userData = {
            email: this.state.email,
            password: this.state.password
          };

          console.log('------update password------',userData)

            axios
            .put(process.env.REACT_APP_API_URL+"/api/v1/user/update-password", userData)
            
            .then(res => {

                this.setState({show_loader: false});

                if(res.data.message == 'password updated') {
                  console.log('-------update------------', res.data.message);
                  this.setState({ msg:res.data.message });
                }else {
                  console.log('-------Not update------------',res.data.message);
                  this.setState({ msg:res.data.message });
                }
            })
            .catch(err =>{
                this.setState({show_loader: false});
                console.log('there is problem', err);

                this.setState({ msg:'there is problem' });
            });
        }
 
      };


    render() {

        const {password,errors,isLoading,updated}=this.state;

    return (

        <div className="container">
        <div className="row">
          <div className="login-bg">
            <div className="login-box">
              <div className="col-md-7 col-lg-5 col-sm-6 text-light mx-auto">
              
              <div className="col-12">
                <img src="./images/login-logo.png" className="login-logo" />
                <p className="login-tagline">Update Password</p>
              </div>
              <form className = "form-horizontal pt-1" role = "form"  noValidate onSubmit={this.resetPassword} autocomplete="off">
              
                <div className="login-inner">

                {(
                    ()=>{
                        if(this.state.msg == "password updated") {
                          return  <div id="msg"  style={{color:'green'}}>Password updated successfully. Click <a href="/login">here</a> to login</div>;
                        } else {
                      
                            return  <div id="msg"  style={{color:'red'}}>{this.state.msg}</div>;                     
                        }
                    }
                  )()}
              
              
                <div className = "form-group mt-4 mb-0">
               
                    <span className="text-danger">{errors.password}{errors.passwordincorrect}{errors.message}</span>
                    <label>Enter new password</label>
                    <input type="password"  id="password" onChange={this.handleChange('password')} onKeyUp={this.checkValidation}  value={this.state.password} error={errors.password} className={classnames("", { invalid: errors.password || errors.passwordincorrect }) + 'form-control'} />
					
                </div>
				{ this.state.showHelpPopup && 
					<div className="password_check_form">
						<div className="pass_check_title">Your password needs to:</div>
						<div className="pass_main_line">
							<div className={ "pass_done_icon " + ( !this.state.contain8Ch ? "pass_iks_icon" : "" ) }></div>
							<div className="pass_line_text">Minimum of 8 characters</div>
                   
                </div>
						<div className="pass_main_line">
							<div className={ "pass_done_icon " + ( !this.state.letterContain ? "pass_iks_icon" : "" ) }></div>
							<div className="pass_line_text">Minimum of 1 Letter</div>
						</div>
						<div className="pass_main_line">
							<div className={ "pass_done_icon " + ( !this.state.numberContain ? "pass_iks_icon" : "" ) }></div>
							<div className="pass_line_text">Minimum of 1 Number</div>
						</div>
						<div className="pass_main_line">
							<div className={ "pass_done_icon " + ( !this.state.specialSymbol ? "pass_iks_icon" : "" ) }></div>
							<div className="pass_line_text">Minimum of 1 Special Character</div>
							<div className="pass_line_text spec_char">(e.g. !,@,#,$,%,&,*)</div>
						</div>
					</div>
				}
                
                <div className = "form-group mt-4 mb-0">
                   
                    <label> Confirm Password</label>
                    <input type="password"  id="cpassword" onChange={this.handleChange('cpassword')} value={this.state.cpassword}   className = "form-control"  />                  
                </div>
                
                <input type="hidden" name='email' id="email"  value={this.props.location.state.email} className = "form-control"  /> 

                <div className = "form-group pt-3 mb-4">
                    <div className = "d-flex flex-wrap justify-content-between align-items-center">
                      {/* <button type = "button" className="btn-cancel btn btn-large btn-outline-secondary waves-effect waves-light hoverable blue accent-3 rounded p-3 px-4">Cancel</button> */}
                      <button type = "submit" className="btn-login btn btn-large btn-primary waves-effect waves-light hoverable blue accent-3 p-3 px-4 rounded">Submit</button>                        
                      <div className={classnames({'circle':true, 'mx-3':true, 'mr-185': true, 'd-none':!this.state.show_loader})}></div>
                    </div>
                </div>
                
              </div>
                                
            </form> 

            </div>
            </div>
            <a href="#" className="privacy-link">Click to view the virdio privacy policy</a>
          </div>
          
        </div>
		
		<SupportContainer supportPageName={this.state.supportPageName} supportPageApi={this.state.supportPageApi} userTypeFaqs={this.state.userTypeFaqs}></SupportContainer>
      </div>

     );

     }

}

const container = {
    "padding": "0px 15px",
    "max-width": "1140px"
  
  };


export default connect()(ResetPassword);